module.exports = __webpack_public_path__ + "img/lg_ring_g_skip_null_null@2x.a34d0a7f.png";